// extracted by mini-css-extract-plugin
export default {"description":"SetPasswordModal_description__RRoNG"};